import { createPinia, type PiniaPluginContext } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

export default defineNuxtPlugin(({ $pinia }) => {
   $pinia.use(piniaPluginPersistedstate);
});